<template>
  <ul class="iq-timeline" data-cy="lead-timeline">
    <li
      v-for="(event, index) in eventsWithDescription"
      :key="index"
      data-cy="lead-timeline-item"
    >
      <div class="timeline-dots" :class="'border-' + event.color"></div>
      <h6 class="float-left mb-1" v-html="event.title"></h6>
      <small class="float-right mt-1" v-html="event.right"></small>
      <div class="d-inline-block w-100">
        <small v-for="i in event.description" :key="i.key" class="d-block">
          <div v-if="i.key === 'emailSent'">
            <strong>Message ID:</strong> {{ i.value.messageId }}
          </div>
          <div v-if="i.key === 'emailClicked'">
            <strong>URL:</strong> {{ i.value.url }}
            <br />
            <strong>Position in email:</strong>
            {{ i.value.index + 1 }}
          </div>
          <div v-if="i.key === 'error'">
            <strong>Error:</strong> {{ i.value }}
          </div>
          <!-- <strong v-if="i.key === 'emailOpened'">{{ i.key }}: </strong
          >{{ i.value }} -->
        </small>
        <!-- <p v-html="event.description"></p>
        {{ Object.keys(event.description) }} -->
        <!-- <p v-if="k in Object.keys(JSON.parse(event.description))">
          <strong>{{ k }}: </strong> value
        </p> -->
        <!-- <template
          v-if="item.child.items.length > 0 && item.child.type === 'img'"
        >
          <div class="iq-media-group">
            <a
              href="#"
              class="iq-media"
              v-for="(childItem, childIndex) in item.child.items"
              :key="childIndex"
            >
              <img
                :src="childItem"
                class="img-fluid avatar-40 rounded-circle"
                alt="img"
              />
            </a>
          </div>
        </template> -->
      </div>
    </li>
  </ul>
</template>

<script>
function eventTypeIcon(eventType) {
  switch (eventType) {
    case "LEAD_STAGE_CHANGED":
      return "fas fa-angle-double-right";
    case "LEAD_DEAL_VALUE_CHANGED":
      return "far fa-money-bill-alt";
    case "EMAIL_SENT":
      return "far fa-paper-plane";
    case "EMAIL_OPENED":
      return "far fa-envelope-open";
    case "EMAIL_CLICKED":
      return "far fa-hand-pointer";
    case "EMAIL_ERROR":
      return "far fa-paper-plane";
    default:
      return "fa fa-calendar-o";
  }
}
export default {
  name: "TimeLine",
  props: {
    events: { type: Array, default: () => [] }
  },
  computed: {
    eventsWithDescription() {
      return this.$props.events.map(i => {
        let newDesc = {};
        if (i.data) {
          newDesc = Object.keys(i.data).map(k => ({
            key: k,
            value: i.data[k]
          }));
        }
        return {
          id: i.id,
          description: newDesc,
          color: "primary",
          title: `<i class="${eventTypeIcon(
            i.event_type
          )} mr-2"></i>  ${i.event_type.replaceAll("_", " ")}`,
          date: i.created_at,
          right: this.$options.filters.formatDate(i.created_at),
          child: {
            type: "img",
            items: []
          }
        };
      });
    }
  }
};
</script>
